import * as React from 'react';
import PropTypes from 'prop-types';

import SlideTitle from './SlideTitle';

/**
 * Columns
 */

const Columns = ({ data }) => (
  <ul className="columns">
    {data.map((data, index) => (
      <li key={index}>
        {data.title && <SlideTitle title={data.title} />}
        {data.text && <p>{data.text}</p>}
      </li>
    ))}
  </ul>
);

Columns.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Columns;
